module.exports = __webpack_public_path__ + "img/V35.09a47010.jpg";